import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/lib/store";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const { finishGoogle } = useApp();
    const nav = useNavigate();
    const done = useRef(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (done.current) return;
        done.current = true;
        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            setError("Missing session_id in redirect.");
            return;
        }
        const sid = decodeURIComponent(m[1]);
        (async () => {
            try {
                await finishGoogle(sid);
                window.history.replaceState(null, "", "/dashboard");
                nav("/dashboard", { replace: true });
            } catch (e) {
                console.error(e);
                setError(e?.response?.data?.detail || "Google sign-in failed.");
                toast.error("Google sign-in failed");
                setTimeout(() => nav("/login", { replace: true }), 1500);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="min-h-screen grain flex items-center justify-center">
            <div className="text-center">
                <Loader2 className="h-8 w-8 text-indigo-400 mx-auto animate-spin" />
                <div className="mt-4 text-slate-300 font-semibold">
                    Signing you in with Google…
                </div>
                {error && (
                    <div className="mt-3 text-sm text-rose-300">{error}</div>
                )}
            </div>
        </div>
    );
}
